import React from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { CONTACT_INFO } from "../lib/data";

export const WhatsAppFab = () => {
  const { t } = useLang();
  const url = `https://wa.me/${CONTACT_INFO.whatsappClean}?text=${encodeURIComponent(t.whatsapp.message)}`;
  return (
    <motion.a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 200 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="pulse-ring fixed bottom-6 right-6 z-50 flex h-14 w-14 sm:h-16 sm:w-16 items-center justify-center rounded-full text-white shadow-xl"
      style={{ backgroundColor: "var(--shk-whatsapp)" }}
      aria-label="WhatsApp"
    >
      <MessageCircle className="h-7 w-7 sm:h-8 sm:w-8 fill-white" strokeWidth={0} />
    </motion.a>
  );
};
